import { CircularProgress, CircularProgressLabel } from '@chakra-ui/react';

interface IProps {
  value: number;
  label: string;
}

const TimeIndicator = (props: IProps) => {
  const { value, label } = props;
  return (
    <CircularProgress
      aria-label="Estimation of time to complete"
      trackColor="chakra-border-color"
      value={value}
      color="active"
      size="144px"
    >
      <CircularProgressLabel fontWeight="semibold" fontSize="2xl">
        {label}
      </CircularProgressLabel>
    </CircularProgress>
  );
};

export { TimeIndicator };
